export const reportCheckList = [
  {
    name: "Car location is wrong",
    flag: false,
    id: 1,
  },
  {
    name: "Unauthorize use of images",
    flag: false,
    id: 2,
  },
  {
    name: "Inaccurate car images",
    flag: false,
    id: 3,
  },
  {
    name: "Unauthorize use of cars",
    flag: false,
    id: 4,
  },
  {
    name: "invalid contact details",
    flag: false,
    id: 5,
  },
  {
    name: "Others",
    flag: false,
    id: 6,
  },
];

export const FinancialGoal = [
  {
    id: 1,
    value: "Cover your car payment",
    label: "Cover your car payment",
    flag: false,
  },
  {
    id: 2,
    value: "Generate side income",
    label: "Generate side income",
    flag: false,
  },
  {
    id: 3,
    value: "Expand an existing business",
    label: "Expand an existing business",
    flag: false,
  },
  {
    id: 4,
    value: "Build a primary source of income",
    label: "Build a primary source of income",

    flag: false,
  },
  {
    id: 5,
    value: "Not sure yet",
    label: "Not sure yet",
    flag: false,
  },
];

export const CurrentlyUse = [
  {
    id: 1,
    name: "Never",
    flag: false,
  },
  {
    id: 2,
    name: "Rarely: once a week or less",
    flag: false,
  },
  {
    id: 3,
    name: "Sometimes: a few days per week",
    flag: false,
  },
  {
    id: 4,
    name: "Often: most days per week",
    flag: false,
  },
  {
    id: 5,
    name: "Always: every day",
    flag: false,
  },
];

export const ShareYourCar = [
  {
    id: 1,
    name: "Never",
    flag: false,
  },
  {
    id: 2,
    name: "Rarely: once a week or less",
    flag: false,
  },
  {
    id: 3,
    name: "Sometimes: a few days per week",
    flag: false,
  },
  {
    id: 4,
    name: "Often: most days per week",
    flag: false,
  },
  {
    id: 5,
    name: "Always: every day",
    flag: false,
  },
];

export const AdvanceNotice = [
  {
    id: 1,
    name: "6 hours",
    flag: false,
  },
  {
    id: 2,
    name: "12 hours ",
    flag: false,
  },
  {
    id: 3,
    name: "1 day",
    flag: false,
  },
];

export const LongestTrip = [
  {
    id: 1,
    name: "5 days",
    flag: false,
  },
  {
    id: 2,
    name: "1 week",
    flag: false,
  },
  {
    id: 3,
    name: "2 weeks",
    flag: false,
  },
  {
    id: 4,
    name: "1 month",
    flag: false,
  },
  {
    id: 5,
    name: "3 month",
    flag: false,
  },
  {
    id: 5,
    name: "Any",
    flag: false,
  },
];

export const Features = [
  {
    id: 1,
    name: "All-wheel drive",
    flag: false,
    val: "allWheelDrive",
  },
  {
    id: 2,
    name: "Android Auto",
    flag: false,
    val: "androidAuto",
  },
  {
    id: 3,
    name: "Apple CarPlay",
    flag: false,
    val: "applyCarPlay",
  },
  {
    id: 4,
    name: "Backup camera",
    flag: false,
    val: "backupCamera",
  },
  {
    id: 5,
    name: "Bike rack",
    flag: false,
    val: "bikeRack",
  },
  {
    id: 5,
    name: "Blind spot warning",
    flag: false,
    val: "blindSpotWining",
  },
  {
    id: 6,
    name: "Bluetooth",
    flag: false,
    val: "bluetooth",
  },
  {
    id: 7,
    name: "Child seat",
    flag: false,
    val: "childSeat",
  },
  {
    id: 8,
    name: "Convertible",
    flag: false,
    val: "convertable",
  },
  {
    id: 9,
    name: "GPS",
    flag: false,
    val: "gps",
  },
  {
    id: 10,
    name: "Heated seats",
    flag: false,
    val: "heatedSeats",
  },

  {
    id: 11,
    name: "Keyless entry",
    flag: false,
    val: "keylessEntry",
  },
  {
    id: 12,
    name: "Pet Friendly",
    flag: false,
    val: "petFriendly",
  },
  {
    id: 13,
    name: "Ski rack",
    flag: false,
    val: "skiRack",
  },
  {
    id: 14,
    name: "Snow tires and chains",
    flag: false,
    val: "snowTyres",
  },
  {
    id: 15,
    name: "Sunroof",
    flag: false,
    val: "sunRoof",
  },
  {
    id: 16,
    name: "Toll pass",
    flag: false,
    val: "tollPass",
  },
  {
    id: 17,
    name: "USB charger",
    flag: false,
    val: "usbCharges",
  },
  {
    id: 18,
    name: "USB input",
    flag: false,
    val: "usbInput",
  },
  {
    id: 19,
    name: "Wheel chair",
    flag: false,
    val: "wheelChair",
  },
];

export const transmission = [
  {
    id: 1,
    label: "Auto",
    value: "Auto",
    flag: false,
  },
  {
    id: 2,
    label: "Manual",
    value: "Manual",
    flag: false,
  },
];
